import { render, staticRenderFns } from "./uploadKnowledge.vue?vue&type=template&id=f776bf40&scoped=true"
import script from "./uploadKnowledge.vue?vue&type=script&lang=js"
export * from "./uploadKnowledge.vue?vue&type=script&lang=js"
import style0 from "./uploadKnowledge.vue?vue&type=style&index=0&id=f776bf40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f776bf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f776bf40')) {
      api.createRecord('f776bf40', component.options)
    } else {
      api.reload('f776bf40', component.options)
    }
    module.hot.accept("./uploadKnowledge.vue?vue&type=template&id=f776bf40&scoped=true", function () {
      api.rerender('f776bf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/uploadKnowledge.vue"
export default component.exports